import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EventTrackerService } from './event-tracker.service';

@Injectable({
  providedIn: 'root',
})
export class HqRouteService {
  private allHqRoutes = [];
  private allRouteValid: boolean = true;

  constructor(
    private router: Router,
    private _eventTracker: EventTrackerService
  ) {}

  get isAllRouteValid() {
    return this.allRouteValid;
  }

  postLogin(permissions, hqData?) {
    this.allRouteValid = true;
    this.allHqRoutes = [
      { name: 'ee_hq', routeUrl: 'hq/dashboard', permissions: ['CAN_VIEW_HQ'] },
      {
        name: 'ee_outlets',
        routeUrl: 'hq/outlets',
        permissions: ['CAN_VIEW_HQ_OUTLETS'],
      },
      {
        name: 'reports',
        routeUrl: 'hq/reports',
        permissions: ['CAN_VIEW_HQ_REPORT'],
      },
      {
        name: 'analytics',
        routeUrl: 'hq/analytics',
        permissions: ['CAN_VIEW_HQ_RESTAURANT_ANALYTICS'],
      },
      {
        name: 'staff_center',
        routeUrl: 'hq/staff-center',
        permissions: [
          'CAN_VIEW_HQ_STAFF_SETTINGS',
          'CAN_VIEW_HQ_ROLES',
          'CAN_VIEW_HQ_TABLE_SETTINGS',
        ],
      },
      {
        name: 'inventory',
        routeUrl: 'hq/inventory',
        permissions: ['CAN_VIEW_HQ_INVENTORY_LIST'],
      },
      {
        name: 'promotion',
        routeUrl: 'hq/discounts',
        permissions: ['CAN_VIEW_HQ_PROMOTION_SETTINGS'],
      },
      { name: 'no_permission', routeUrl: 'hq/no-permission', isValid: true },
    ];

    this.allHqRoutes.forEach((el) => {
      if (el.name !== 'no_permission') {
        let found = false;
        for (let i = 0; i < el.permissions.length; i++) {
          if (permissions.indexOf(el.permissions[i]) > -1) {
            found = true;
            el.isValid = found;
            break;
          }
        }
      }
    });

    console.log(this.allHqRoutes);

    if (hqData) {
      this._eventTracker.easyeat_track_event('HQ_Main_Screen_Viewed', {
        User_Email_ID: hqData.user_email,
        User_name: hqData.user_name,
        HQ_ID: hqData.hq_id,
        HQ_Name: hqData.hq_name,
      });

      this._eventTracker.easyeat_track_event('HQ_Viewed_Dashboard', {
        User_Email_ID: hqData.user_email,
        User_name: hqData.user_name,
        HQ_Opened: hqData.hq_name,
        Screen_Resolution: `${window.innerWidth} x ${window.innerHeight}`
      });
    }

    for (let i = 0; i < this.allHqRoutes.length; i++) {
      let currEl = this.allHqRoutes[i];
      if (currEl.isValid) {
        this.router.navigate([currEl.routeUrl]);
        currEl.name === 'no_permission' && (this.allRouteValid = false);
        break;
      }
    }
  }
}
